import StackAPI from '@/lib/StackAPI'

export interface RequestOrgUserPasswordResetParams {
  email: string
  recaptchaToken: string | null
}

const ENDPOINT = '/org_users/request_password_reset'

export const requestOrgUserPasswordReset = async ({
  email,
  recaptchaToken
}: RequestOrgUserPasswordResetParams) => {
  const { post } = StackAPI()

  const request = {
    path: ENDPOINT,
    params: {
      email,
      recaptcha_token: recaptchaToken
    },
    headers: {
      'Content-Type': 'application/json'
    }
  }

  return await post(request)
    .then((response) => {
      if (response.status !== 200) {
        throw new Error('Failed to send reset instructions')
      }
      return response.data
    })
    .catch((error) => {
      throw new Error(error.message || 'Failed to send reset instructions')
    })
}
